import axios from 'axios';

export const saveCarrierPackages = async (data) => {
  await axios.post('/seller/packagetypes', data);
};

export const addCustomPackage = async (data) => {
  const response = await axios.post('/seller/custompackages', data);
  return response.data;
};

export const editCustomPackage = async (data) => {
  await axios.put('/seller/custompackages', data);
};

export const deleteCustomPackage = async (packageTypeId) => {
  await axios.delete(`/seller/custompackages/${packageTypeId}`);
};
